import { jobItemOutput } from './job.item.output'

export const jobListOutput = (payload) => {
  const { data, locale } = payload

  return data.map((item) => jobItemOutput({ data: item, locale }))
}
